import { render, staticRenderFns } from "./OrgData.vue?vue&type=template&id=30260d27&scoped=true"
import script from "./OrgData.vue?vue&type=script&lang=js"
export * from "./OrgData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30260d27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30260d27')) {
      api.createRecord('30260d27', component.options)
    } else {
      api.reload('30260d27', component.options)
    }
    module.hot.accept("./OrgData.vue?vue&type=template&id=30260d27&scoped=true", function () {
      api.rerender('30260d27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/uc/OrgData.vue"
export default component.exports